import { create } from 'zustand';

const initialState = {
    selectedPatient: null,
    typedSearch: {},
    selectedEquipments: {},
    equipmentList: [],
    selectedSearch: {},
};

// Restored lightweight store for the already implemented assistance screens.
export const useTechnicalAssistanceStore = create((set) => ({
    ...initialState,
    setSelectedPatient: (selectedPatient) => set({ selectedPatient }),
    setTypedSearch: (typedSearch) => set({ typedSearch: typedSearch ?? {} }),
    setSelectedEquipment: (selectedEquipments, typedSearch) =>
        set({
            selectedEquipments: selectedEquipments ?? {},
            ...(typedSearch !== undefined
                ? { typedSearch: typedSearch && typeof typedSearch === 'object' ? typedSearch : {} }
                : {}),
        }),
    setEquipmentList: (equipmentList) => set({ equipmentList: equipmentList ?? [] }),
    setSelectedSearch: (selectedSearch) => set({ selectedSearch: selectedSearch ?? {} }),
    reset: () => set({ ...initialState }),
}));
